import { makeStyles } from "@saleor/macaw-ui";

const useStyle = makeStyles(
  () => ({
    container: {
      backgroundColor: "white",
      height: "100%",
      boxShadow: `0px 4px 16px rgba(0, 0, 0, 0.12)`,
      borderRadius: "8px",
      padding: "24px",
      maxWidth: "40%"
    },
    uploadBox: {
      border: `1px dashed #009FB8`,
      padding: "24px",
      height: "80%",
      borderRadius: "4px",
      backgroundColor: "#F2FAFB",
      cursor: "pointer",
      "&:hover": {
        boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.16)"
      }
    },
    titleContainer: {
      display: "flex"
    },
    title: {
      paddingBottom: "24px",
      color: "#333333"
    },
    adjustIconToolTips: {
      cursor: "pointer",
      marginLeft: "auto"
    },
    adjustIcon: {
      fill: "slategray"
    },
    buttonWrapper: {
      borderRadius: "4px"
      // "& :hover": {
      //   background: "#555555"
      // }
    },
    button: {
      borderRadius: "4px",
      maxWidth: "164px",
      width: "164px",
      height: "48px",
      display: "flex",
      alignItems: "center",
      justifyContent: "space-around",
      padding: "16px 22px 16px 22px",
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400
    },
    buttonTitle: {
      color: "white",
      fontSize: "18px",
      paddingLeft: "12px",
      fontFamily: "ScgFont, sans-serif",
      fontWeight: 400
    },
    infoIcon: { marginRight: "10.5px" },
    fileName: { marginRight: "18px", marginLeft: "6px" },
    icon: {
      height: "13.46px",
      width: "12.38px",
      top: "2.29px",
      left: "3px",
      cursor: "pointer"
    },
    uploadResult: {
      padding: "0px 0px 24px 0px",
      borderBottom: "solid 1px #E0E0E0"
    },
    browse: {
      padding: "0px 4px 0px 4px",
      fontWeight: 700,
      fontSize: "14px",
      color: "#009FB8"
    },
    dragTitle: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      color: "#009FB8",
      fontSize: "14px"
    },
    supportTitle: {
      color: "#999999",
      fontSize: "12px"
    },
    note: {
      fontSize: "14px",
      color: "#E41B17"
    }
  }),
  { name: "UploadFile" }
);

export default useStyle;
